/* eslint-disable max-len */
import React from 'react';
import ReactPaginate from 'react-paginate';
import { getPaginationDetails } from '../../CommonMethods/GetPaginationCount';

const Pagination = ({ totalPageNumber, selectedPageNumber, handleOnClickPageNumber, TotalCount, limit }) => {

    return (
        <div className="flex items-center pb-[2px] mt-3">
            <div className="w-[60%] flex justify-end">
                <ReactPaginate
                    previousLabel={
                        <a
                            href="#"
                            className={`rounded w-[30px] h-[30px] flex justify-center prev 
                        ${
        Number(selectedPageNumber) === 1
            ? " bg-[#818E98]"
            : " bg-[#106EB4]"
        }`}
                        >
                            <img
                                loading="lazy"
                                decoding="async"
                                src="/images/chevrons-left.svg"
                                alt="icon"
                                className="w-[8px]"
                            />
                        </a>
                    }
                    nextLabel={
                        <a
                            href="#"
                            className={` rounded w-[30px] h-[30px] flex justify-center ml-4 next 
                        ${
        Number(selectedPageNumber) === totalPageNumber
            ? " bg-[#818E98]"
            : " bg-[#106EB4]"
        }`}
                        >
                            <img
                                loading="lazy"
                                decoding="async"
                                src="/images/chevrons-left.svg"
                                alt="icon"
                                className="w-[8px] rotate-180"
                            />
                        </a>
                    }
                    breakLabel="..."
                    pageCount={totalPageNumber}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    forcePage={selectedPageNumber - 1}
                    onPageChange={handleOnClickPageNumber}
                    containerClassName="flex justify-center items-center"
                    pageClassName=" font-regular text-[#555259] px-2 rounded w-max h-5 inline-flex
                justify-center items-center ml-4 hover:text-[#106EB4]"
                    activeClassName="border border-[#106EB4]"
                />
            </div>
            <div class="w-[39.5%] flex justify-end">
                <div class="border border-[#c2dcef] rounded bg-[#EEF7FE] bg-opacity-20 shadow-s11 px-3 py-1 text-[#106EB4]">
                    {getPaginationDetails(selectedPageNumber, TotalCount, limit)}
                </div>
            </div>
        </div>
    );
};

export default Pagination;
